import { render, staticRenderFns } from "./DynamicChapterSearch.vue?vue&type=template&id=1c60da73&scoped=true&"
import script from "./DynamicChapterSearch.vue?vue&type=script&lang=js&"
export * from "./DynamicChapterSearch.vue?vue&type=script&lang=js&"
import style0 from "./DynamicChapterSearch.vue?vue&type=style&index=0&id=1c60da73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60da73",
  null
  
)

export default component.exports